import { createActions } from 'redux-actions';
import { put } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  SYSTEM_STATUS: {
    HEALTH: undefined,
    API: {
      HEALTH: apiResourceActionCreator('health')
    }
  }
})

export const apiAction = () => commonApiActions.get(`${API_ENDPOINT}`, actions.systemStatus.api.health)

export function* getSystemStatus(action) {
  yield put(apiAction(action.payload && action.payload.query));
}

const configuration = {
  name: 'health',
  action: actions,
  sagas: getSystemStatus,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false,
      health: {
        buildVersion: action.payload.health.buildVersion
      },
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      isLoadingMore: false,
      error: action.payload.error
    }),
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/system-status/configurations/health.js